import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import CalculadoraFinanciamento from './pages/CalculadoraFinanciamento';
import Properties from './pages/Properties';
import Leads from './pages/Leads';
import Plans from './pages/Plans';
import Clientes from './pages/Clientes';
import CRM from './pages/CRM';
import Perfil from './pages/Perfil';
import SimuladorFinanciamento from './pages/SimuladorFinanciamento';
import AdminLayout from './components/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminTenants from './pages/admin/AdminTenants';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPlanos from './pages/admin/AdminPlanos';
import AdminTokens from './pages/admin/AdminTokens';
import AdminLogs from './pages/admin/AdminLogs';
import AdminConfig from './pages/admin/AdminConfig';
import AdminLogin from './pages/admin/AdminLogin';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center">
      <div className="w-8 h-8 border-3 border-[#064E3B]/20 border-t-[#064E3B] rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center">
      <div className="w-8 h-8 border-3 border-[#0f3d2e]/20 border-t-[#0f3d2e] rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/admin/login" replace />;
  if (user.role !== 'super_admin') return <Navigate to="/" replace />;
  return <AdminLayout>{children}</AdminLayout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

      {/* Simulador — lançamento, pré-lançamento usam a mesma página com query param */}
      <Route path="/calculadora" element={<ProtectedRoute><CalculadoraFinanciamento /></ProtectedRoute>} />
      <Route path="/simulador/financiamento" element={<ProtectedRoute><SimuladorFinanciamento /></ProtectedRoute>} />

      {/* Clientes (substitui Leads na sidebar) */}
      <Route path="/clientes" element={<ProtectedRoute><Clientes /></ProtectedRoute>} />
      {/* Leads mantido internamente para não quebrar links existentes */}
      <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />

      {/* Produtos (renomeado de Imóveis) */}
      <Route path="/imoveis" element={<ProtectedRoute><Properties /></ProtectedRoute>} />

      {/* CRM */}
      <Route path="/crm" element={<ProtectedRoute><CRM /></ProtectedRoute>} />

      {/* Perfil do corretor */}
      <Route path="/perfil" element={<ProtectedRoute><Perfil /></ProtectedRoute>} />

      {/* Planos */}
      <Route path="/planos" element={<ProtectedRoute><Plans /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/tenants" element={<AdminRoute><AdminTenants /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/planos" element={<AdminRoute><AdminPlanos /></AdminRoute>} />
      <Route path="/admin/tokens" element={<AdminRoute><AdminTokens /></AdminRoute>} />
      <Route path="/admin/logs" element={<AdminRoute><AdminLogs /></AdminRoute>} />
      <Route path="/admin/config" element={<AdminRoute><AdminConfig /></AdminRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
